<template>
  <div class="w-full lg:grid lg:grid-cols-1 min-h-[100vh] pt-14 sm:pt-0">
    <div class="flex items-center justify-center py-12">
      <form @submit.prevent="resetPassword(
         { token, password },
        () => toast({
          title: 'Senha redefinida com sucesso',
          class: 'bg-green-500 text-white'
        }),
        () => toast({
          title: 'Não foi possível redefinir a senha',
          description: 'Link de redefinição inválido ou expirado',
          variant: 'destructive'
        })
      )" class="mx-auto grid w-full p-4 sm:p-0 sm:w-[390px] gap-6">
        <div class="grid gap-2 text-center">
          <!-- <KeyRound class="h-28 w-28 mx-auto pb-4" /> -->
          <div class="flex justify-center mb-4">
            <img src="https://dashboard.hoopay.com.br/img/hoopay-logo.png" alt="Logo Hoopay" class="max-h-[50px] w-auto object-contain" />
          </div>
          <div class="flex items-center gap-3 mx-auto">
            <h1 class="text-3xl font-bold">
              Redefinir senha
            </h1>
          </div>
          <p class="text-muted-foreground">
            Digite uma nova senha para a sua conta
          </p>
        </div>
        <div class="grid gap-4">
          <div class="grid gap-2">
            <Label for="password">Senha</Label>
            <Input
              id="password"
              type="password"
              placeholder="ex: 123"
              required
              v-model="password"
            />
          </div>
          <Button type="submit" class="w-full py-6 mt-6" :disabled="isAuthLoading || !password"> 
            <Loader2 v-if="isAuthLoading" class="w-4 h-4 mr-2 animate-spin" />
            Salvar
          </Button>
        </div>
      </form>
    </div>
  </div>
  <Toaster />
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/components/ui/toast/use-toast'
import { Toaster } from '@/components/ui/toast'
import { onMounted, ref } from 'vue'
import { Loader2 } from 'lucide-vue-next'
import { useAuth } from '@/composables/useAuth'
import { useTenant } from '@/composables/useTenant'

defineProps<{ token: string }>()
const { toast } = useToast()
const password = ref('')
const { resetPassword, isAuthLoading } = useAuth()
const { tenantLogo, initializeTenant } = useTenant()
onMounted(() => {
  initializeTenant()
})
</script>